import RequestService from './request';

interface CustomMapUrlCheckData {
    url: string;
}

class RustCustomMapUrlService {
    async check(data: CustomMapUrlCheckData): Promise<{ valid: boolean }> {
        return RequestService.post('/servers/:server/rust/custom-map-url/check', data);
    }
}

export default new RustCustomMapUrlService();
